module.exports = __webpack_public_path__ + "static/media/darren-coleshill.46fe8377.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/examples/darren-coleshill.jpg
// module id = 1130
// module chunks = 0